import { Injectable, computed, signal } from '@angular/core';
import { RenderProgressSnapshot } from '../models/render-progress.model';

@Injectable({ providedIn: 'root' })
export class RenderProgressStore {
  private readonly progressSignal = signal<RenderProgressSnapshot | null>(null);

  readonly progress = computed(() => this.progressSignal());

  set(progress: RenderProgressSnapshot | null): void {
    this.progressSignal.set(progress);
  }

  clear(): void {
    this.progressSignal.set(null);
  }
}
